
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppFileUpload, AppSwitch } from '@/components';
import { useAvatarDefaultAdd } from '@/modules/avatar/default/model/add';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.DEFAULT.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppFileUpload, AppSwitch },
    setup() {
        const { model, v$, create, typeList, genderList } = useAvatarDefaultAdd();

        return { v$, model, create, typeList, genderList };
    }
});
